module.exports = __webpack_public_path__ + "static/promlens-tree-10ff8c8a6d2bbdac4ca79eeec09cae10.png";